package com.mgacreative.hotel.domain.di

import com.mgacreative.hotel.domain.repository.*
import org.koin.dsl.module

fun getDomainModule() = module {
    single<ReservationRepository> { ReservationRepositoryImpl(get(), getOrNull()) }
    single<RoomRepository> { RoomRepositoryImpl(get(), getOrNull()) }
    single<PricingRepository> { PricingRepositoryImpl(get(), getOrNull()) }
    single<GuestRepository> { GuestRepositoryImpl(get()) }
    single<ShiftRepository> { ShiftRepositoryImpl(get(), get()) }
    single<StaffRepository> { StaffRepositoryImpl(get(), get()) }
    single<FinanceRepository> { FinanceRepositoryImpl(get(), get()) }
    single<PosRepository> { PosRepositoryImpl(get(), get(), get()) }
    single<InventoryRepository> { InventoryRepositoryImpl(get(), get()) }
    single<PurchasingRepository> { PurchasingRepositoryImpl(get(), get(), get()) }
    single<SupplierRepository> { SupplierRepositoryImpl(get()) }
    single<AgencyRepository> { AgencyRepositoryImpl(get()) }
    single<DepartmentRepository> { DepartmentRepositoryImpl(get(), get()) }
    single<BlacklistRepository> { BlacklistRepositoryImpl(get()) }
}
